const popoverParents = document.querySelectorAll('[data-popover-parent]');
popoverParents.forEach((popoverParent) => {
    const popoverContent = popoverParent.querySelector('[data-popover-content]');
    if (popoverContent == null) {
        return;
    };

    popoverParent.addEventListener('click', (event) => {
        if (event.target.matches('button') || event.target.closest('button')) return;
        if (popoverContent.classList.contains('display')) {
            return;
        }

        popoverParents.forEach((popoverParent) => popoverParent.querySelector('[data-popover-content]')?.classList.remove('display'));
        popoverContent.classList.add('display');

        const { top, left } = getElementPosition(popoverParent, popoverContent);
        const arrow = popoverContent.querySelector('.arrow');
        const position = {
            arrowLeft: getArrowLeftPosition(popoverParent, arrow),
            popupTop: top,
            popupLeft: left
        }

        const clonedPopoverContent = setUpPopoverContent(popoverContent, position);
        const popoverBtnClose = clonedPopoverContent.querySelector('[data-popover-close]');
        if (popoverBtnClose !== null) {
            setTimeout(() => {
                popoverBtnClose.focus();
            }, 300);
        }

        popoverBtnClose?.addEventListener('click', (event) => {
            event.preventDefault();
            if (clonedPopoverContent !== null) {
                clonedPopoverContent.classList.remove('show');
                setTimeout(() => {
                    clonedPopoverContent.remove();
                }, 150);
                popoverContent.classList.remove('display');
            }
        });

        // Click outside to close popover
        document.addEventListener('click', (e) => {
            if (!popoverParent.contains(e.target) && !clonedPopoverContent.contains(e.target)) {
                clonedPopoverContent.classList.remove('show');
                setTimeout(() => {
                    clonedPopoverContent.remove();
                }, 150);
                popoverContent.classList.remove('display');
            }
        });
    });

});

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        const activeEl = document.activeElement;
        if (activeEl && activeEl.classList.contains('btn-close-popover')) {
            activeEl.click();
        }
    }
});

function setUpPopoverContent(originalElement, position) {
    const clonedElement = originalElement.cloneNode(true); // true = clone cả con cháu
    clonedElement.classList.add('clone', 'fade');
    clonedElement.style.setProperty('transform', `translate3d(${position.popupLeft}px, ${position.popupTop}px, 0)`);
    document.body.appendChild(clonedElement);
    setTimeout(() => {
        clonedElement.classList.add('show');
    }, 0);

    const rect = clonedElement.getBoundingClientRect();
    const viewport = Math.min(window.outerWidth, window.innerWidth)
    let overflowRight = Math.max(0, rect.right - viewport);
    let overflowLeft = Math.max(0, -rect.left); // Nếu left < 0 => tràn trái
    const gutter = 15;

    if (overflowLeft > 0) {
        overflowLeft += gutter;
    }

    if (overflowRight > 0) {
        overflowRight += gutter;
    }

    const transX = position.popupLeft - overflowRight + overflowLeft;
    const arrowLeft = position.arrowLeft - transX;

    clonedElement.style.setProperty('transform', `translate3d(${transX}px, ${position.popupTop}px, 0)`);
    clonedElement.style.setProperty('--arrow-left', `${arrowLeft}px`);

    return clonedElement;
}

function getElementPosition(popupParent, popupContent) {
    const topRect = popupParent.getBoundingClientRect();
    const scrollTop = window.scrollY || window.pageYOffset;
    let top = topRect.top + scrollTop;
    const height = popupParent.offsetHeight;

    const translateY = top + height + 10;

    const topCenter = topRect.left + topRect.width / 2;

    const bottomWidth = popupContent.offsetWidth;
    const leftForBottom = topCenter - bottomWidth / 2;

    const translateXCenter = leftForBottom;

    return {
        top: translateY,
        left: translateXCenter
    }
}

function getArrowLeftPosition(target, arrow) {
    const rect = target.getBoundingClientRect();
    const arrowLeft = rect.left + rect.width / 2 - arrow.offsetWidth / 2;
    return arrowLeft;
}